import { apiFetch } from '@/lib/api';
import type { Role } from '@/services/teamService';
import type { User } from '@/services/authService';

export interface InviteValidateResponse {
  tenant_name: string;
  role: Role;
  email: string;
}

export interface InviteAcceptRequest {
  name: string;
  password: string;
}

export interface InviteAcceptResponse {
  access_token: string;
  token_type: string;
  user: User;
  email_verification_required: boolean;
}

export const inviteService = {
  validate(token: string): Promise<InviteValidateResponse> {
    return apiFetch<InviteValidateResponse>(`/public/invitations/${token}`, {
      skipAuth: true,
    });
  },

  accept(token: string, payload: InviteAcceptRequest): Promise<InviteAcceptResponse> {
    return apiFetch<InviteAcceptResponse>(`/public/invitations/${token}/accept`, {
      method: 'POST',
      body: JSON.stringify(payload),
      skipAuth: true,
    });
  },
};
